__turbopack_context__.v({
  "footer": "QBRvuW_footer",
  "imageWrapper": "QBRvuW_imageWrapper",
  "link": "QBRvuW_link",
  "subHeading": "QBRvuW_subHeading",
  "wrapper": "QBRvuW_wrapper",
});
